class SideTabs {
    constructor(sideTabEl) {
        this.el = sideTabEl;
        this.tabLinks = this.el.querySelectorAll('.tab-menu-item');
        this.tabs = this.el.querySelectorAll('.block-side-tabs__tab');
        
        this.setEventHandlers();
    }

    setEventHandlers() {
        this.el.querySelectorAll('.tab-menu-item').forEach( (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const tabData = e.target.dataset.tab;
                const tab = this.el.querySelectorAll('.'+tabData);

                // remove active class
                this.tabLinks.forEach(tl => {
                    tl.classList.remove('active');
                })

                // hide all tabs
                this.tabs.forEach(t => {
                    t.classList.remove('display');
                })

                // add active class link
                e.target.classList.add('active');
                // show tab and image
                tab.forEach(t => {
                    t.classList.add('display');
                })
            });
        });
    }
}

export default SideTabs;